
// * ========================================================================
// * deadMonth chart
// * ========================================================================

import CovidChart from './covid-chart.js';
import moment from 'moment';
import storage from './../storage';

const deadMonth = (function() {
    const typeSelectorClass = 'input[name=dead-month-chart-data]';
    let dataType = null;
    let typeSelectors = null;
    let thisChart;
    let hightestValue = 0;
    let chartData = null;

    /**
     *
     * Create new chart
     *
     * @param {Object} data - covid data
     * @param {Object} options - covid options
     *
     * @returns {Object} - chart
     */
    function createChartData(data, options) {
        //const chartFirstDate = window.config.firstDayValues['medical'];

        let datasets = [{
            id: 'total',
            label: 'Yhteensä',
            barPercentage: 1,
            backgroundColor: 'pink',
            labelColor: 'pink',
            borderColor: 'rgba(0,0,0,1)',
            borderWidth: 0,
            count: 0,
            type: 'line',
            fill: false,
            data: []
        }, {
            id: 'leading',
            label: 'Pääkuolinsyy',
            backgroundColor: '#000',
            hoverBackgroundColor: '#000',
            barPercentage: 1,
            borderColor: '#000',
            borderWidth: 0,
            count: 0,
            type: 'bar',
            fill: true,
            data: []
        },{
            id: 'contributing',
            label: 'Kuolemaan myötävaikuttanut',
            backgroundColor: '#666',
            hoverBackgroundColor: '#666',
            barPercentage: 1,
            borderColor: '#666',
            borderWidth: 0,
            count: 0,
            type: 'bar',
            fill: true,
            data: []
        }];

        // Create data
        const loopData = dataType === 'weeks' ? data.dead.weeks : dataType === 'years' ? data.dead.years : data.dead.months;
        for (let item of loopData) {
            const date = moment(item.date);

            // Push only after first visible date
            //if (date >= chartFirstDate) {
            datasets[0].count += item.count;
            datasets[0].data.push({
                x: date,
                y: item.count
            });
            datasets[1].count += item.leading;
            datasets[1].data.push({
                x: date,
                y: item.leading
            });
            datasets[2].count += item.contributing;
            datasets[2].data.push({
                x: date,
                y: item.contributing
            });

            if (item.count > hightestValue) {
                hightestValue = item.count;
            }
            //}
        }

        return datasets;
    }

    function getDataType(initialType = null) {
        let initialCheckbox = null;
        if (initialType) {
            initialCheckbox = document.querySelector(typeSelectorClass + '[value="'+initialType+'"]');
        }

        if (initialCheckbox) {
            initialCheckbox.checked = true;
            dataType = initialType;
            return dataType;
        }

        dataType = document.querySelector(typeSelectorClass+':checked').value;

        return dataType;
    }

    function addMarginToHighest() {
        const margin = dataType === 'weeks' ? 20 : dataType === 'months' ? 50 : 500;
        hightestValue += margin;
    }

    function getTimeFormat() {
        if (dataType === 'weeks') {
            return {
                unit: 'week',
                tooltipFormat: 'W / YYYY',
                displayFormats: {
                    week: 'W / YYYY',
                }
            };
        } else if (dataType === 'months') {
            return {
                unit: 'month',
                tooltipFormat: 'MMM YYYY',
                displayFormats: {
                    day: 'M',
                }
            };
        } else {
            return {
                unit: 'year',
                tooltipFormat: 'YYYY',
                displayFormats: {
                    year: 'YYYY',
                }
            };
        }
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        chartData = data;

        typeSelectors = document.querySelectorAll(typeSelectorClass);
        const initialType = storage.getData(typeSelectorClass);

        // Get the data type we want to show
        getDataType(initialType);

        // Create datasets
        const datasets = createChartData(chartData, window.config);

        addMarginToHighest();

        const timeFormat = getTimeFormat();

        // Get delay
        /*let delayDate = datasets[0].data[datasets[0].data.length - 1].x;
        const dayNumber = moment().date();
        if (dayNumber < 22) { // If day of the month is less than 22, prev month is still unfinished
            delayDate = datasets[0].data[datasets[0].data.length - 2].x;
        }
        const lag = -(45);
        const delay = moment(delayDate).add(lag, 'day').format('YYYY-MM-DD');*/

        thisChart = new CovidChart('dead-month-chart', {
            datasets,
            chartOptions: {
                type: 'bar',
                options: {
                    plugins: {
                        legend: {
                            display: true
                        },
                        tooltip: {
                            callbacks: {
                                label: function(tooltipItem) {
                                    if (tooltipItem.raw.y === 0) {
                                        return null;
                                    }

                                    let label = tooltipItem.dataset.label + ': ' || '';
                                    label = label + tooltipItem.formattedValue;

                                    return label;
                                },
                            },
                        },
                        /*annotation: {
                            annotations: [
                                {
                                    type: 'line',
                                    mode: 'vertical',
                                    scaleID: 'x',
                                    value: delay,
                                    borderColor: '#e80a9a',
                                    borderWidth: 2,
                                    label: {
                                        content: 'Viive',
                                        enabled: true,
                                        position: 'top',
                                        rotation: 0,
                                        xAdjust: 25,
                                        yAdjust: 4,
                                        xPadding: 4,
                                        yPadding: 5,
                                        backgroundColor: '#e80a9a'
                                    }
                                }
                            ]
                        },*/
                    },
                    scales: {
                        x: {
                            type: 'time',
                            stacked: true,
                            offset: true,
                            time: timeFormat
                        },
                        y: {
                            stacked: true,
                            min: 0,
                            max: hightestValue,
                            ticks: {
                                precision: 0
                            }
                        }
                    }
                }
            },
            config: window.config,
            responsive: ['aspectRatio'],
            tooltips: {
                elementId: 'dead-month-chart-tooltip',
                customHeadingType: 'as-is'
            }
        });

        // Create listener for type change
        typeSelectors.forEach((typeSelector) => {
            typeSelector.addEventListener('change', () => {
                let newType = document.querySelector(typeSelectorClass+':checked').value;
                storage.updateData(typeSelectorClass, newType);
                if (dataType !== newType) {
                    reload(null, true);
                }
            });
        });
    }

    function reload(data = null, changeType = false) {
        if (!changeType) {
            return; // No need to reload
        }

        if (data) {
            chartData = data;
        }

        // Get the data type we want to show
        getDataType();

        hightestValue = 0;
        const datasets = createChartData(chartData, window.config);

        thisChart.updateDatasets(datasets);

        addMarginToHighest();
        thisChart.chart.options.scales.y.max = hightestValue;

        const timeFormat = getTimeFormat();
        thisChart.chart.options.scales.x.time.unit = timeFormat.unit;
        thisChart.chart.options.scales.x.time.tooltipFormat = timeFormat.tooltipFormat;
        thisChart.chart.options.scales.x.time.displayFormats = timeFormat.displayFormats;

        thisChart.chart.update();
    }

    return {
        init,
        reload
    }

})();

export default deadMonth;
